/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YearlyEndingNav
 */
export interface YearlyEndingNav {
    /**
     * 
     * @type {string}
     * @memberof YearlyEndingNav
     */
    brokerAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof YearlyEndingNav
     */
    pId: string;
    /**
     * 
     * @type {number}
     * @memberof YearlyEndingNav
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyEndingNav
     */
    endingNav?: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyEndingNav
     */
    currentNav?: number;
}

/**
 * Check if a given object implements the YearlyEndingNav interface.
 */
export function instanceOfYearlyEndingNav(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "brokerAccountId" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "year" in value;

    return isInstance;
}

export function YearlyEndingNavFromJSON(json: any): YearlyEndingNav {
    return YearlyEndingNavFromJSONTyped(json, false);
}

export function YearlyEndingNavFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyEndingNav {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brokerAccountId': json['broker_account_id'],
        'pId': json['p_id'],
        'year': json['year'],
        'endingNav': !exists(json, 'ending_nav') ? undefined : json['ending_nav'],
        'currentNav': !exists(json, 'current_nav') ? undefined : json['current_nav'],
    };
}

export function YearlyEndingNavToJSON(value?: YearlyEndingNav | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'broker_account_id': value.brokerAccountId,
        'p_id': value.pId,
        'year': value.year,
        'ending_nav': value.endingNav,
        'current_nav': value.currentNav,
    };
}

